import React from "react";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import styles from "../../Dobavljaci.module.scss";

const { Text, Paragraph } = Typography;

const FinansijskiPodaci = ({ supplierState, goBack }) => {
  return (
    <>
      <Row className="pl-4 pr-1 pt-8 pb-2">
        <Col span={6}>
          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.minDuration : 1}
            labelAlign="right"
            label="Trajanje min"
            name="trajanje-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.defaultDuration : 5}
            labelAlign="right"
            label="Trajanje def"
            name="trajanje-def"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.maxDuration : 10}
            labelAlign="right"
            label="Trajanje max"
            name="trajanje-max"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.minAmount : 1}
            labelAlign="right"
            label="Iznos min"
            name="iznos-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState && supplierState.defaultAmount}
            labelAlign="right"
            label="Iznos def"
            name="iznos-def"
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState && supplierState.maxAmount}
            labelAlign="right"
            label="Iznos max"
            name="iznos-max"
          >
            <Input min={0} type="number" />
          </Form.Item>
        </Col>
        <Col span={6} className="ml-6 mr-2">
          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.minDownPayment : 1}
            labelAlign="right"
            label="Akontacija min"
            name="akontacija-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState && supplierState.defaultDownPayment}
            labelAlign="right"
            label="Akontacija def"
            name="akontacija-def"
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState && supplierState.maxDownPayment}
            labelAlign="right"
            label="Akontacija max"
            name="akontacija-max"
          >
            <Input min={0} type="number" />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            colon={false}
            className="mb-3"
            initialValue={supplierState ? supplierState.commission : 50}
            labelAlign="right"
            label="Provizija "
            name="provizija"
            wrapperCol={{
              offset: 1,
              span: 13,
            }}
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>
          <div className="pt-4 pb-2 px-4 border rounded">
            <div className="flex items-center gap-2 mb-2">
              <InfoCircleOutlined className="text-light-blue-login text-2xl" />
              <Text>Napomena</Text>
            </div>
            <Paragraph className="text-[10px] text-black text-opacity-40">
              Unesite proviziju u procentima, ali bez znaka procenta
            </Paragraph>
          </div>
        </Col>
      </Row>
      <div className="border-b opacity-40 w-[98%] m-auto"></div>

      <Row className="pl-4 pt-8 ">
        <Col span={6}>
          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.minParticipation : 5}
            labelAlign="right"
            label="Učešće min"
            name="ucesce-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={
              supplierState ? supplierState.defaultParticipation : 10
            }
            labelAlign="right"
            label="Učešće def"
            name="ucesce-def"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.maxParticipation : 49}
            labelAlign="right"
            label="Učešće max"
            name="ucesce-max"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input min={0} type="number" />
          </Form.Item>
        </Col>

        <Col span={6} className="ml-[6px]">
          <Form.Item
            colon={false}
            className="ml-[-16px]"
            initialValue={supplierState ? supplierState.minProcessingFee : 0.01}
            labelAlign="right"
            label="Trošak obrade min"
            name="obrada-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input className="w-[94%]" type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            className="ml-[-16px]"
            initialValue={
              supplierState ? supplierState.defaultProcessingFee : 0.01
            }
            labelAlign="right"
            label="Trošak obrade def"
            name="obrada-def"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input className="w-[94%]" type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            className="ml-[-16px]"
            initialValue={supplierState && supplierState.maxProcessingFee}
            labelAlign="right"
            label="Trošak obrade max"
            name="obrada-max"
          >
            <Input className="w-[94%]" type="number" />
          </Form.Item>
        </Col>

        <Col span={6} className="ml-[15px] ">
          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.minInterestRate : 3.99}
            labelAlign="right"
            label="Kamata min"
            name="kamata-min"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={
              supplierState ? supplierState.defaultInterestRate : 4.99
            }
            labelAlign="right"
            label="Kamata def"
            name="kamata-def"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            initialValue={supplierState ? supplierState.maxInterestRate : 6.99}
            labelAlign="right"
            label="Kamata max"
            name="kamata-max"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            className="ml-[-20px]"
            initialValue={
              supplierState ? supplierState.minPhysicalInterestRate : 4.99
            }
            labelAlign="right"
            label="Kamata fizička min"
            name="fizička"
            wrapperCol={{
              offset: 1,
              span: 9,
            }}
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input className="w-[102%]" type="number" />
          </Form.Item>

          <Form.Item
            colon={false}
            className={styles.wrapLabel}
            initialValue={supplierState && supplierState.olInterestRate}
            labelAlign="right"
            label="Definisana kamatna stopa za OL"
            name="kamata-OL"
            rules={[
              {
                required: true,
                message: "Obavezno polje!",
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      <div className="flex">
        <Form.Item>
          <Button
            htmlType="button"
            onClick={goBack}
            className="ml-10 mt-3 text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm"
          >
            NAZAD
          </Button>
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            className="ml-10 mt-3 text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm"
          >
            SPREMI
          </Button>
        </Form.Item>
      </div>
    </>
  );
};

export default FinansijskiPodaci;
